import { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import EditCompanyDialog from './EditCompanyDialog';

EditCompanyButton.propTypes = {
  company: PropTypes.object.isRequired,
  // No-arg callback invoked after a successful update — typically the
  // parent's `refetch` for the companies list.
  onUpdated: PropTypes.func
};

EditCompanyButton.defaultProps = {
  onUpdated: null
};

export default function EditCompanyButton({ company, onUpdated }) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDialogOpen = (event) => {
    event.stopPropagation();
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <EditCompanyDialog
        isOpen={dialogOpen}
        closeHandler={handleDialogClose}
        onUpdated={onUpdated}
        company={company}
      />
      <Tooltip title={`Edit ${company.name}`}>
        <IconButton onClick={handleDialogOpen} color="primary">
          <EditOutlinedIcon data-testid="edit-company-icon" />
        </IconButton>
      </Tooltip>
    </>
  );
}
